/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

import { switchMap, first } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { fromPaymentActions, paymentQuery, PaymentState } from '../../+state/table';

/**
 * Gets CreditHistory for payment-screen
 */
@Injectable()
export class CreditHistoryResolver {
  constructor(private _store: Store<PaymentState>) {}

  /*
   * Resolve CreditHistory
   * 1. Selects getCreditHistory from the store
   * 3. Check if CreditHistory is present
   * - If state is empty:
   *   1. Call getCreditHistory
   * 4. Return creditHistory from store.
   */
  public resolve(): Observable<any> {
    return this._store.select(paymentQuery.getCreditHistory).pipe(
      switchMap(creditHistory => {
        // TODO
        // for now we cannot use cached data
        // there is no delta sync/realtime infrastructure
        this.getCreditHistory();
        return of(creditHistory);

        // if (!creditHistory) {
        //   this.getCreditHistory();
        // }
        // return of(creditHistory);
      }),
      first()
    );
  }

  /*
   * trigger fetching CreditHistory
   * 1. Dispatch getCreditHistory action
   */
  private getCreditHistory() {
    this._store.dispatch(fromPaymentActions.getCreditHistory());
  }
}
